import { Routes } from '@angular/router';

// import { CognitoLoginComponent } from './login/cognito-login.component';
import { JwtLoginComponent } from './login/jwt-login.component';

export const PagesRoutes: Routes = [
  {
    path: '',
    component: JwtLoginComponent,
  },
];
